/** The MagicBI logo (public/logos): the assistant's mark in the nav bar and every chat. */
export const MAGICBI_LOGO_SRC = "/logos/magicbi.svg";
